/**
 * POST every enabled webhook in parallel. Surfaces per-target results so
 * the Toolbar can render a flash for success/failure.
 */
export const dispatchAnnotation = async (annotation, webhooks) => {
    const targets = webhooks.filter((w) => w.enabled && w.url.length > 0);
    if (targets.length === 0)
        return [];
    return Promise.all(targets.map(async (hook) => {
        try {
            const res = await fetch(hook.url, {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    ...(hook.headers ?? {}),
                },
                body: JSON.stringify(annotation),
            });
            return {
                id: hook.id,
                url: hook.url,
                ok: res.ok,
                status: res.status,
            };
        }
        catch (err) {
            return {
                id: hook.id,
                url: hook.url,
                ok: false,
                error: err instanceof Error ? err.message : String(err),
            };
        }
    }));
};
//# sourceMappingURL=dispatcher.js.map